// extracted by mini-css-extract-plugin
export default {"fkBlue":"#0063be","fkGrey":"#efefef","fkDarkGrey":"#636363","fkWhite":"#fff","header":"Header_header__QJfsy","logo":"Header_logo__eQM7L"};